var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { OptionMenuItemEntityValue } from "./option-menu-item-entity-value";
export var OptionMenuItemEntityValueSlim = function (props) {
  return React.createElement(OptionMenuItemEntityValue, __assign({}, props, {
    minHeight: 18,
    valueProps: {
      variant: 'smallName'
    }
  }));
};